const BRANCH_METHOD_LIST = (
  'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview ' +
  'deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData ' +
  'setIdentity track validateCode trackCommerceEvent logEvent disableTracking'
).split(' ');

// webview mode
const minimal = new URLSearchParams(window.location.search).get('minimal');

export function initializeBranchIO() {
  if (minimal === 'true') return;
  if (window.branch && window.branch._q) return;

  console.log('Initializing Branch.');
  const branch = { _q: [], _v: 1 };
  for (let i = 0; i < BRANCH_METHOD_LIST.length; ++i) {
    const methodName = BRANCH_METHOD_LIST[i];
    // Cannot use an arrow function since we need the "arguments" binding.
    branch[methodName] = function() { branch._q.push([methodName, arguments]); };
  }
  const branchScript = document.createElement('script');
  branchScript.async = 1;
  branchScript.src = 'https://cdn.branch.io/branch-latest.min.js';
  const node = document.getElementsByTagName('script')[0];
  node.parentNode.insertBefore(branchScript, node);
  window.branch = branch;
}
